export const ZOHO_SCOPES = [
  "ZohoSearch.securesearch.READ",
  "WorkDrive.collection.READ",
  "WorkDrive.comments.READ",
  "WorkDrive.files.READ",
  "WorkDrive.users.READ",
  "WorkDrive.groups.READ",
  "WorkDrive.organization.READ",
  "WorkDrive.members.READ",
  "WorkDrive.team.READ",
  "WorkDrive.teamfolders.admin.READ",
  "WorkDrive.teamfolders.READ",
  "WorkDrive.teamfolders.sharing.READ",
  "WorkDrive.workspace.READ",
  "ZohoCRM.users.READ",
  "ZohoCRM.org.READ",
  "ZohoCRM.settings.READ",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.READ",
  "WorkDrive.collection.CREATE",
  "WorkDrive.comments.CREATE",
  "WorkDrive.DataTemplates.CREATE",
  "WorkDrive.files.CREATE",
  "WorkDrive.groups.CREATE",
  "WorkDrive.members.CREATE",
  "WorkDrive.team.CREATE",
  "WorkDrive.teamfolders.CREATE",
  "WorkDrive.teamfolders.sharing.CREATE",
  "WorkDrive.workspace.CREATE",
  "ZohoCRM.users.CREATE",
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.modules.CREATE",
  "WorkDrive.collection.UPDATE",
  "WorkDrive.comments.UPDATE",
  "WorkDrive.DataTemplates.UPDATE",
  "WorkDrive.groups.UPDATE",
  "WorkDrive.members.UPDATE",
  "WorkDrive.team.UPDATE",
  "WorkDrive.teamfolders.UPDATE",
  "WorkDrive.teamfolders.sharing.UPDATE",
  "WorkDrive.workspace.UPDATE",
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.modules.UPDATE",
  "WorkDrive.files.UPDATE",
  "WorkDrive.files.ALL",
  "WorkDrive.files.DELETE",
];

export const ZOHO_READ_SCOPES = [
  "ZohoSearch.securesearch.READ",
  "WorkDrive.collection.READ",
  "WorkDrive.comments.READ",
  "WorkDrive.files.READ",
  "WorkDrive.users.READ",
  "WorkDrive.groups.READ",
  "WorkDrive.organization.READ",
  "WorkDrive.members.READ",
  "WorkDrive.team.READ",
  "WorkDrive.teamfolders.admin.READ",
  "WorkDrive.teamfolders.READ",
  "WorkDrive.workspace.READ",
  "ZohoCRM.users.READ",
  "ZohoCRM.org.READ",
  "ZohoCRM.settings.READ",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.READ",
];

export const ZOHO_UPDATE_SCOPES = [
  "WorkDrive.collection.UPDATE",
  "WorkDrive.comments.UPDATE",
  "WorkDrive.DataTemplates.UPDATE",
  "WorkDrive.groups.UPDATE",
  "WorkDrive.members.UPDATE",
  "WorkDrive.team.UPDATE",
  "WorkDrive.teamfolders.UPDATE",
  "WorkDrive.workspace.UPDATE",
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.modules.UPDATE",
  "WorkDrive.files.UPDATE",
];

export const ZOHO_CREATE_SCOPES = [
  "WorkDrive.comments.CREATE",
  "WorkDrive.DataTemplates.CREATE",
  "WorkDrive.files.CREATE",
  "WorkDrive.groups.CREATE",
  "WorkDrive.members.CREATE",
  "WorkDrive.team.CREATE",
  "WorkDrive.teamfolders.CREATE",
  "WorkDrive.workspace.CREATE",
  "ZohoCRM.users.CREATE",
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.modules.CREATE",
];

export const ZOHO_DELETE_SCOPES = ["WorkDrive.files.DELETE"]; 

export const ZOHO_SHARE_SCOPES = [
  "WorkDrive.teamfolders.sharing.CREATE",
  "WorkDrive.teamfolders.sharing.READ",
  "WorkDrive.teamfolders.sharing.UPDATE",
];

export const permissions = [
  {
    name: "Admin",
    details: "Full control",
    scopes: ZOHO_SCOPES,
    buttons: [
      "Rename",
      "Copy",
      "Paste",
      "Cut",
      "Download",
      "Ext. Share Link(Download Only)",
      "Ext. Share Link(Full Access)",
      "Collect Files",
      "Open in Workdrive",
      "Delete",
      "Sync Attachments",
      "Refresh",
      "Go to WorkDrive Folder",
      "Share Current Folder(Download Only)",
      "Share Current Folder(Full Access)",
      "Folder",
      "fileupload",
    ],
  },
  {
    name: "Organizer",
    details: "Can organize, share, create, edit, and manage members",
    scopes: ZOHO_SCOPES,
    buttons: [
      "Rename",
      "Copy",
      "Paste",
      "Cut",
      "Download",
      "Ext. Share Link(Download Only)",
      "Ext. Share Link(Full Access)",
      "Collect Files",
      "Open in Workdrive",
      "Delete",
      "Sync Attachments",
      "Refresh",
      "Go to WorkDrive Folder",
      "Share Current Folder(Download Only)",
      "Share Current Folder(Full Access)",
      "Folder",
      "fileupload",
    ],
  },
  {
    name: "Editor",
    details: "Can create, edit, and comment",
    scopes: [
      ...ZOHO_READ_SCOPES,
      ...ZOHO_UPDATE_SCOPES,
      ...ZOHO_CREATE_SCOPES,
      ...ZOHO_SHARE_SCOPES,
    ],
    buttons: [
      "Rename",
      "Copy",
      "Paste",
      "Cut",
      "Download",
      "Ext. Share Link(Download Only)",
      "Ext. Share Link(Full Access)",
      "Open in Workdrive",
      "Sync Attachments",
      "Refresh",
      "Go to WorkDrive Folder",
      "Share Current Folder(Download Only)",
      "Share Current Folder(Full Access)",
      "Folder",
      "fileupload",
    ],
  },
  {
    name: "Commenter",
    details: "Can view and comment",
    scopes: ZOHO_READ_SCOPES,
    buttons: [
      "Download",
      "Open in Workdrive",
      "Refresh",
      "Go to WorkDrive Folder",
    ],
  },
  {
    name: "Viewer",
    details: "Can view",
    scopes: ZOHO_READ_SCOPES,
    buttons: [
      "Download",
      "Open in Workdrive",
      "Refresh",
      "Go to WorkDrive Folder",
    ],
  },
];

export const getRoleButtons = (role) => {
  return permissions.find((permission) => permission?.name === role)?.buttons;
};

export const CLIQ_SCOPES = [
  "ZohoCliq.Messages.READ",
  "ZohoCliq.Channels.UPDATE",
  "ZohoCliq.Channels.CREATE",
  "ZohoCliq.Chats.ALL",
  "ZohoCliq.Teams.READ",
  "ZohoCliq.Users.READ",
  "ZohoCliq.Buddies.READ",
  "ZohoCliq.Chats.READ",
  "ZohoCliq.Profile.CREATE",
  "ZohoCliq.Webhooks.CREATE",
  "ZohoCliq.Reminders.READ",
  "ZohoCliq.Channels.READ",
];
